import type { FC } from "react"
import React, { createContext, useContext, useMemo } from "react"

interface PendingApprovalsContextValue {
  refetchTaskCounts: () => void
}

interface PendingApprovalsProviderProps {
  refetchTaskCounts: () => void
  children: React.ReactNode
}

const PendingApprovalsContext = createContext<PendingApprovalsContextValue | undefined>(undefined)

export const PendingApprovalsProvider: FC<PendingApprovalsProviderProps> = ({ refetchTaskCounts, children }) => {
  const value = useMemo(() => ({ refetchTaskCounts }), [refetchTaskCounts])

  return <PendingApprovalsContext.Provider value={value}>{children}</PendingApprovalsContext.Provider>
}

export const usePendingApprovalsContext = (): PendingApprovalsContextValue => {
  const context = useContext(PendingApprovalsContext)

  if (!context) {
    throw new Error("usePendingApprovalsContext must be used within a PendingApprovalsProvider")
  }

  return context
}
